import { SET_CURRENT_USER } from "redux/types";

const setCurrentUser = (payload) => {
    return { type: SET_CURRENT_USER, payload };
};

export { setCurrentUser };
